// media.js
import React from 'react';
import './media.scss';

// Static data for your articles
const articles = [
  {
    id: 1,
    title: "Top Dieticians in India Who Are Transforming Lives",
    introduction: "Fitoja aims to redefine how people look at diet and lifestyle transformation in India. It offers more than just dietetics, serving as a digital wellness platform. With a team of expert nutritionists, constant support, and customised plans for various conditions–including weight loss, PCOS, diabetes, fatty liver, or post-pregnancy weight–Fitoja delivers real results...",
    thumbnail: "https://www.hindustantimes.com/ht-img/img/2025/07/07/original/HINDUSTAN_TIMES_02_1751876385644.png", // Replace with your actual image path
    link: "https://www.hindustantimes.com/genesis/top-dieticians-in-india-who-are-transforming-lives-101750931521098.html", // Replace with actual article link
    source: "Hindustan Times",
    date: "May 10, 2025"
  },
  {
    id: 2,
    title: "Fitoja's Success Story: Bridging the Gap in Health Tech",
    introduction: "Dailyhunt features Fitoja's journey and impact on the health and wellness sector, emphasizing our user-centric design and effective programs. Learn about the technology driving our success and user testimonials...",
    thumbnail: "https://via.placeholder.com/150/33FF57/FFFFFF?text=DH_Fitoja", // Replace with your actual image path
    link: "https://www.dailyhunt.in/fitoja-success-story-example-67890", // Replace with actual article link
    source: "Dailyhunt",
    date: "April 22, 2025"
  },
  {
    id: 3,
    title: "The Future of Wellness: A Deep Dive into Fitoja's Ecosystem",
    introduction: "An in-depth report on how Fitoja is shaping the future of digital wellness, integrating AI and personalized coaching for unparalleled results. Explore our vision for a healthier tomorrow...",
    thumbnail: "https://via.placeholder.com/150/3357FF/FFFFFF?text=Biz_Fitoja", // Replace with your actual image path
    link: "https://www.businessinsider.in/fitoja-future-of-wellness-example-11223", // Replace with actual article link
    source: "Business Insider India",
    date: "March 15, 2025"
  },
  {
    id: 4,
    title: "Fitoja: Empowering Individuals Through Personalized Fitness",
    introduction: "Outlook India covers Fitoja's commitment to empowering users with tailored fitness plans and expert guidance, making fitness achievable for all. Read about our community impact and unique features...",
    thumbnail: "https://via.placeholder.com/150/FF33E9/FFFFFF?text=Out_Fitoja", // Replace with your actual image path
    link: "https://www.outlookindia.com/fitoja-empowering-individuals-example-44556", // Replace with actual article link
    source: "Outlook India",
    date: "February 01, 2025"
  }
  // Add more articles as needed
];

const MediaScreen = () => {
  return (
    <div className="media-page">
      <h1 className="media-page-title">Fitoja In The News</h1>
      <p className="media-page-subtitle">Catch up on what the media is saying about Fitoja's mission to transform health and wellness.</p>
      <div className="articles-container">
        {articles.map((article, index) => (
          <div key={article.id} className={`article-card ${index % 2 === 0 ? 'image-left' : 'image-right'}`}>
            <div className="article-thumbnail">
              <img src={article.thumbnail} alt={article.title} />
            </div>
            <div className="article-content">
              <h2 className="article-title">{article.title}</h2>
              <p className="article-meta">
                <span className="article-source">{article.source}</span> &bull; <span className="article-date">{article.date}</span>
              </p>
              <p className="article-introduction">{article.introduction}</p>
              <a href={article.link} target="_blank" rel="noopener noreferrer" className="read-more-button">
                Read More <span className="arrow">→</span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaScreen;